<!--suppress ALL -->
<script lang="ts">
	import {Component, Prop, Extend, Mixin} from 'annotation';
	import {Line, mixins} from 'vue-chartjs'
	import {cloneDeep, isNil} from 'lodash';

	@Component
	export default class LineChart extends Mixin(mixins.reactiveProp) {

		@Prop({default: []})
		public labels: Array<string>;

		@Prop({required: true})
		public datas: Array<any>;

		@Prop({default: {}})
		public options: Object;

		public afterCreated: boolean;

		@Extend
		public extend() {
			return Line
		}

		public get properties() {
			return [this.datas, this.labels];
		}

		public mounted() {
			this.afterCreated = true;
			this.createChart();
		}

		public get datasets() {
			const {datas} = this;

			return cloneDeep(datas).map((item) => {
				// automaticaly sets bgColor if there is no bg color
				if (isNil(item.backgroundColor)) {
					item.backgroundColor = window.randomColor({
						count: 1,
						hue: 'red'
					})[0];
				}

				return item;
			});
		}

		public get chartData() {
			const {labels, datasets} = this;

			return {labels, datasets};
		}

		public createChart() {
			const {chartData, options} = this;

			this.renderChart(chartData, options);
		}
	}
</script>
